import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AppAccessService } from '../services/app-access.service';

export const routeRestrictionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const appAccessService = inject(AppAccessService);
  const router = inject(Router);

  // Build the full URL from the route
  const fullPath =
    '/' +
    route.pathFromRoot
      .filter((r) => r.url.length > 0)
      .map((r) => r.url.map((segment) => segment.path).join('/'))
      .join('/');

  // Check if this route can be accessed
  const canAccess = appAccessService.canAccessRoute(fullPath);

  if (!canAccess) {
    // If access is not allowed, redirect to form-builder (the only allowed route)
    router.navigate(['/form-builder']);
    return false;
  }

  return true;
};
